import React, { useEffect, useState } from "react";
import {
  CFormInput,
  CContainer,
  CRow,
  CCol,
  CBadge,
} from "@coreui/react";
import "./QuizComponent.css";

function FillInTheBlanks({
  type,
  num,
  question,
  score,
  onAnswerChange,
  questionID,
  questionTypeID,
  isCorrect,
  valueReset,
  correctAnswer, 
  userAnswer,
  isReviewLoaded,
  isQuestionsFetched,
  currentPage,
}) {
  const [value, setValue] = useState("");

  useEffect(() => {
    // Reset value when questionID changes or valueReset is triggered
    setValue("");
  }, [questionID, valueReset]);

  const isDisabled = type === "review";

  const handleSelectAnswer = (newValue) => {
    setValue(newValue);
    onAnswerChange(questionID, questionTypeID, newValue);
  };

  const getClassName = () => {
    if (isCorrect === 1) {
      return "reviewAnswers";
    } else if (isCorrect === 0) {
      return "reviewAnswers2";
    } else {
      return "";
    }
  };
 
  return (
    <CContainer className="mb-3 questionContainer">
      <ol>
        <CRow className="align-items-center">
          {/* Question number */}
          <CCol xs="auto" className="pr-0">
            <span style={{ fontWeight: '650' }}>{`Q${isQuestionsFetched ? currentPage : num + 1})`}</span>
          </CCol>

          {/* Input */}
          <CCol xs={3} sm={2} className="form-group" style={{ paddingRight: '8px' }}>
            <CFormInput
              value={isReviewLoaded ? userAnswer : value}
              disabled={isDisabled}
              className={`border-bottom rounded-0 blank ${getClassName()}`}
              onChange={(e) => handleSelectAnswer(e.target.value)}
              type="text"
            />
          </CCol>

          {/* Question text - take remaining space */}
          <CCol className="pl-0">
            <span style={{ fontWeight: '650' }}>{question}</span>
            <div style={{ padding: '5px' }}>{isReviewLoaded && <p className="mb-0">Correct Answer: {correctAnswer}</p>}</div>
          </CCol>

          {/* Score badge */}
          <CCol xs="auto" className="text-right pl-2">
            <CBadge shape="rounded-pill" color="primary">{score}</CBadge>
          </CCol>
        </CRow>
      </ol>
    </CContainer>
  );
}

export default FillInTheBlanks;
